import React from "react";

import { ReactComponent as DefaultIllustration } from "./droopy-plant-illustration.svg";

import styles from "./EmptyState.module.css";

interface Props {
	/** The main text of the screen */
	title: string;
	/** An illustration element – defaults to the guy with the droopy plant behind him */
	illustration?: React.ComponentType<{ className?: string }>;
	children?: React.ReactNode;
}

export default function EmptyState({
	title,
	illustration: Illustration = DefaultIllustration,
	children,
}: Props): React.FunctionComponentElement<Props> {
	return (
		<div className={styles.emptyState}>
			<Illustration className={styles.emptyStateIllustration} />
			<p className={styles.heading}>{title}</p>
			{children && <div className={styles.text}>{children}</div>}
		</div>
	);
}
